import { ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';

/** Aufklapper innerhalb eines Abschnitts (Board: „Regelwerk vergleichen“, „Kalibrierungsdaten“). */
export function ConfigurationDetails({ title, children }: { title: string; children: ReactNode }) {
  return (
    <details className="border-hairline group rounded-lg border px-4">
      <summary className="focus-visible:outline-forest flex min-h-12 cursor-pointer list-none items-center justify-between gap-3 text-sm font-bold focus-visible:outline focus-visible:outline-2">
        {title}
        <ChevronDown
          aria-hidden
          size={16}
          className="flex-none transition-transform group-open:rotate-180"
        />
      </summary>
      <div className="flex flex-col gap-4 pb-3.5">{children}</div>
    </details>
  );
}
